module.exports = __webpack_public_path__ + "img/vps-header.228c6c6.svg";